import produce from 'immer';
import gql from 'graphql-tag';
import { updateBooleanQueryString } from './updateQueryString';
// QUERY
export const boolFilterValue = function boolFilterValue(parent) {
    return (searchParams) => {
        var _a;
        const query = __IN_SERVER__ ? searchParams : document.location.search;
        // If the search params includes the boolean filter id, the boolean filter
        // must be active
        return (_a = query) === null || _a === void 0 ? void 0 : _a.includes(parent.id);
    };
};
////////////////////////////////////////////////////////////////////////////////
// MUTATION
export const setBoolFilter = (_, { value, id }, { cache, getCacheKey }) => {
    const fragmentId = getCacheKey({
        id,
        __typename: 'BooleanFilter'
    });
    const boolFilter = cache.readFragment({
        fragment: gql `
      fragment BoolFilterState on BooleanFilter {
        id
        value @client
      }
    `,
        id: fragmentId
    });
    const data = produce(boolFilter, draft => {
        draft.value = value === false ? null : value;
    });
    cache.writeData({
        id: fragmentId,
        data
    });
    // Update the active filters in cache
    const activeFilters = updateActiveFilters(cache, data);
    updateBooleanQueryString(activeFilters);
    return data;
};
function updateActiveFilters(cache, data) {
    const activeBoolFilterQuery = gql `
    query GetActiveBoolFilters {
      activeFilters @client {
        booleanFilters {
          id
          value @client
        }
      }
    }
  `;
    const currentActiveFilters = cache.readQuery({ query: activeBoolFilterQuery });
    const { activeFilters } = produce(currentActiveFilters, draft => {
        // Clear this filter from active filters
        if (data.value === null) {
            draft.activeFilters.booleanFilters = draft.activeFilters.booleanFilters.filter(boolFilter => boolFilter.id !== data.id);
        }
        else {
            draft.activeFilters.booleanFilters.push({
                id: data.id,
                value: data.value,
                __typename: 'BooleanFilterInput'
            });
        }
    });
    cache.writeData({ data: { activeFilters } });
    return activeFilters;
}
//# sourceMappingURL=boolFilter.js.map